const COHORT_YEAR = '2024';

export default COHORT_YEAR